module.exports = __webpack_public_path__ + "img/age_verification.53174485.png";